import { Timestamp } from '@bufbuild/protobuf';
export const CORPORATE_EVENT_OPTIONS = [
    {
        value: 'acquired',
        label: 'Acquired',
        relationshipType: 'acquisition',
        companyFrom: false,
        otherLabel: 'Company acquired',
        headcount: true
    },
    {
        value: 'was_acquired_by',
        label: 'Was acquired by',
        relationshipType: 'acquisition',
        companyFrom: true,
        otherLabel: 'Acquirer',
        headcount: true
    },
    {
        value: 'merged_into',
        label: 'Merged into',
        relationshipType: 'merger',
        companyFrom: true,
        otherLabel: 'Surviving company',
        headcount: true
    },
    {
        value: 'subsidiary_of',
        label: 'Subsidiary of',
        relationshipType: 'subsidiary',
        companyFrom: true,
        otherLabel: 'Parent company'
    },
    {
        value: 'parent_of',
        label: 'Parent of',
        relationshipType: 'subsidiary',
        companyFrom: false,
        otherLabel: 'Subsidiary'
    },
    {
        value: 'jv_has_member',
        label: 'Formed JV with members',
        relationshipType: 'jv_member',
        companyFrom: false,
        otherLabel: 'JV member',
        multiple: true
    },
    {
        value: 'joined_jv',
        label: 'Joined JV',
        relationshipType: 'jv_member',
        companyFrom: true,
        otherLabel: 'The JV company'
    },
    {
        value: 'renamed_to',
        label: 'Renamed to',
        relationshipType: 'rename',
        companyFrom: true,
        otherLabel: 'New name (its registry company)'
    },
    {
        value: 'spun_off_from',
        label: 'Spun off from',
        relationshipType: 'spinoff',
        companyFrom: true,
        otherLabel: 'Company it came from'
    },
    {
        value: 'novated_to',
        label: 'Novated contracts to',
        relationshipType: 'novation',
        companyFrom: true,
        otherLabel: 'Company taking the contracts'
    },
    {
        value: 'affiliate_of',
        label: 'Affiliate of',
        relationshipType: 'affiliate',
        companyFrom: true,
        otherLabel: 'Affiliated company'
    },
    {
        value: 'sells_through',
        label: 'Sells through',
        relationshipType: 'reseller',
        companyFrom: true,
        otherLabel: 'Reseller or distributor',
        multiple: true
    },
    {
        value: 'resells_for',
        label: 'Resells for',
        relationshipType: 'reseller',
        companyFrom: false,
        otherLabel: 'Software vendor or OEM',
        multiple: true
    }
];
export function corporateEventOption(value) {
    return CORPORATE_EVENT_OPTIONS.find((o)=>o.value === value);
}
/** The rows one event writes, one per other company. */ export function linksForEvent(event, companyId, otherIds) {
    const opt = corporateEventOption(event);
    if (!opt) return [];
    return otherIds.filter((id)=>id && id !== companyId).map((other)=>({
            relationshipType: opt.relationshipType,
            fromCompanyId: opt.companyFrom ? companyId : other,
            toCompanyId: opt.companyFrom ? other : companyId
        }));
}
/** "2024-06-01" → a UTC-midnight Timestamp; empty → undefined. */ export function dayToTimestamp(day) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return undefined;
    return Timestamp.fromDate(new Date(`${day}T00:00:00Z`));
}
/** A Timestamp → "2024-06-01" (UTC); undefined → "". */ export function timestampToDay(t) {
    return t ? t.toDate().toISOString().slice(0, 10) : '';
}
/**
 * The event in words from this company's side. direction FROM_US: this
 * company is the stored from end.
 */ export function corporateEventSentence(type, fromUs, other) {
    switch(type){
        case 'acquisition':
            return fromUs ? `Acquired by ${other}` : `Acquired ${other}`;
        case 'merger':
            return fromUs ? `Merged into ${other}` : `${other} merged into it`;
        case 'subsidiary':
            return fromUs ? `Subsidiary of ${other}` : `Parent of ${other}`;
        case 'jv_member':
            return fromUs ? `Member of the JV ${other}` : `JV member: ${other}`;
        case 'rename':
            return fromUs ? `Renamed to ${other}` : `Renamed from ${other}`;
        case 'spinoff':
            return fromUs ? `Spun off from ${other}` : `Spun off ${other}`;
        case 'novation':
            return fromUs ? `Novated contracts to ${other}` : `Took over novated contracts from ${other}`;
        case 'affiliate':
            return `Affiliate of ${other}`;
        case 'reseller':
            return fromUs ? `Sells through ${other}` : `Reseller for ${other}`;
        case 'joint_venture':
            return `Joint venture with ${other}`;
        case 'mentor_protege':
            return `SBA mentor–protégé agreement with ${other}`;
        default:
            return `${type.replace(/_/g, ' ')}: ${other}`;
    }
}
/** "Jun 2023", "since Jun 2023 · ended Jan 2025". */ export function corporateEventDates(start, end) {
    const fmt = (t)=>t.toDate().toLocaleDateString('en-GB', {
            month: 'short',
            year: 'numeric',
            timeZone: 'UTC'
        });
    if (start && end) return `${fmt(start)} – ${fmt(end)}`;
    if (start) return fmt(start);
    if (end) return `ended ${fmt(end)}`;
    return 'Date not recorded';
}
